import warning from 'warning';
export function catchUnreachableWarning(guard, returnValue) {
  warning(true, "Unsupported kind: " + JSON.stringify(guard));
  return returnValue;
}